import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { LoadingState } from './loading.state';

@Injectable({ providedIn: 'root' })
export class LoadingFacade {
  loading$: Observable<boolean> = this.store.select(LoadingState.getLoading);

  constructor(private store: Store) {}
}
